import { html } from 'lit-html';
import { each } from '../../../core/component';
import { ItemSearchJsEnv } from '../models/item_search_js_env'
import { SpecSearchKey } from '../models/item_search_spec';
import { ItemSearchAction } from '../actions/item_search_action'

export const initItemSearchModal = () => {
  document.querySelector('.openItemSearchModal')
    ?.addEventListener(
      'click',
      () => {
        ItemSearchAction.openModal();
      }
    );
}

export const checkBoxList = (model: ItemSearchJsEnv) =>{
return html`
<div class="o-table_body">
    ${each(model.specSearchKey, specArea) }
</div>
`;
}

export const Button = (model: ItemSearchJsEnv) =>{
  if (model.isEnable) {
    return html`
     <button class="m-btn -primary -short" type="submit" id="btn_item_search"
             style="max-width:250px"
             @click="${() => ItemSearchAction.searchButton()}">
     <span class="m-btn_inner">
       <span class="m-btn_text">チェックを付けた条件で検索する</span>
     </span>
     </button>`;

  } else {
     return html`
     <button class="m-btn -primary -short is-disabled" type="submit" id="btn_item_search"
        style="max-width:250px" disabled="">
        <span class="m-btn_inner">
         <span class="m-btn_text">チェックを付けた条件で検索する</span>
        </span>
     </button>`;
  }
}

const specArea = (specSearchKey: SpecSearchKey) => html`
  <div class="o-table_tr row" style="display: flex;"
    @mouseover="${(event: Event) => ItemSearchAction.mouseover(event)}"
    @mouseout="${(event: Event) => ItemSearchAction.mouseout(event)}"
    @click="${(event: Event) => ItemSearchAction.disableChanged(event)}">
      <div class="o-table_th" style="width:48px">
        <div class="a-checkbox js-lazy-img">
          <label class="a-checkbox_label">
          <input type="checkbox" class="spec-checkbox"
           name="searchKeyList" value="${specSearchKey.chkTitleCode}_${specSearchKey.chkTitle}_${specSearchKey.chkCode}_${specSearchKey.searchValue}"/>
          <span class="a-checkbox_icon"></span>
          </label>
        </div>
      </div>
      <div class="o-table_td" style="width:176px">
         <p class="a-text">${specSearchKey.searchTitle}</p>
      </div>
      <div class="o-table_td" style="flex-grow: 1">
         <p class="a-text">${specSearchKey.searchValue}</p>
      </div>
    </div>
`;
